import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import omit from 'lodash';
import AssetsFormHandlers from 'containers/assets/AssetsFormHandlers';
import { trimDmsReference } from 'lib/assets/dms_reference';
import Assets from 'components/assets';

import { getVisibleCustomFieldsEmployees } from 'custom_fields_employees/selectors'; //Groups
import { getVisibleGroups } from 'groups/selectors'; //Groups

import { updateAsset, requestUpdateAsset } from 'containers/assets/actions';

import { addGrowlMessage as addMsg } from 'messages/actions';
import { needsNewVoucherNotice } from 'lib/vouchers/custodian';

export class AssetsEditFormView extends Component {
  // The custodian the asset was loaded with: on save, a change of custodian of a
  // client with signing on gets a notice to sign the new custodian's voucher.
  loadedId = null;
  loadedCustodian = null;

  rememberCustodian = () => {
    const { asset } = this.props;
    if (asset && asset.id && asset.id !== this.loadedId) {
      this.loadedId = asset.id;
      this.loadedCustodian = asset._employee || null;
    }
  };

  componentDidMount = () => this.rememberCustodian();

  componentDidUpdate = () => this.rememberCustodian();

  handleSubmit = (e) => {
    let { addMsg, asset, company, history, subcompany, updateAsset, requestUpdateAsset } =
      this.props;

    const isRequest = !!this.props.match.params.isRequest;
    const method = isRequest ? requestUpdateAsset : updateAsset;

    const aId = asset.id;
    const cId = company.id;
    const sId = subcompany.id;

    // Trim BEFORE omit: `omit` here is the whole lodash (line 4), so it returns
    // a wrapper whose toJSON is the asset, and a trim on the wrapper finds nothing.
    asset = omit(trimDmsReference(asset), [
      '_fiscalDepreciationResult',
      '_financialDepreciationResult',
      '_extraDepreciationsResult',
    ]);

    // From the props: after omit() `asset` is a lodash wrapper (see above).
    const newCustodian = this.props.asset && this.props.asset._employee;
    method(aId, cId, sId, asset)
      .then(({ value }) => {
        addMsg(value.message, 'success', 'common.success');
        // A request only applies when accepted: no notice for it.
        if (
          !isRequest &&
          needsNewVoucherNotice(company, subcompany, this.loadedCustodian, newCustodian)
        ) {
          addMsg('custodyVoucher.newCustodianNotice', 'warn', 'common.warning');
        }
        history.push(`/companies/${cId}/subcompanies/${sId}/assets`);
      })
      .catch((e) => {
        addMsg(e.message, 'error', 'common.error');
      });
  };

  render = () => {
    return (
      <AssetsFormHandlers
        render={({
          beforeSubmit,
          uploadFiles,
          handleValidation,
          handleValueChange,
          handleGroupChange, //Groups
          handleCustomFieldChange, //Groups
          isSubmitted,
          isValid,
        }) => {
          return (
            <Assets.Form
              companyId={this.props.company.id}
              subcompanyId={this.props.subcompany.id}
              values={this.props.asset}
              accounts={this.props.accounts}
              catalogs={this.props.catalogs}
              costCenters={this.props.costCenters}
              depreciations={this.props.depreciations}
              employees={this.props.employees}
              handleSubmit={beforeSubmit(uploadFiles(this.handleSubmit))}
              handleValidation={handleValidation}
              handleValueChange={handleValueChange}
              handleGroupChange={handleGroupChange} //Groups
              handleCustomFieldChange={handleCustomFieldChange} //Groups
              groups={this.props.groups} //Groups
              isLoading={this.props.isLoading}
              isSubmitted={isSubmitted}
              locations={this.props.locations}
              projects={this.props.projects}
              providers={this.props.providers}
              subaccounts={this.props.subaccounts}
              sublocations={this.props.sublocations}
              asset_levels={this.props.asset_levels}
            />
          );
        }}
      />
    );
  };
}

const mapStateToProps = (state) => ({
  customfields: getVisibleCustomFieldsEmployees(state), //Groups
  groups: getVisibleGroups(state), //Groups
});
const mapDispatchToProps = { updateAsset, addMsg, requestUpdateAsset };

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AssetsEditFormView));



// WEBPACK FOOTER //
// src/containers/assets/edit_sections/AssetsEditFormSection.js